<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      inactivityTimer: null,
      inactivityTimeout: 30 * 60 * 1000 // 30분 (밀리초)
    }
  },
  mounted() {
    this.setupInactivityTimer();
  },
  beforeUnmount() {
    this.clearInactivityTimer();
  },
  methods: {
    setupInactivityTimer() {
      // 사용자 활동을 감지하는 이벤트들
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

      // 각 이벤트에 리스너 추가
      events.forEach(event => {
        document.addEventListener(event, this.resetInactivityTimer, true);
      });

      // 초기 타이머 시작
      this.resetInactivityTimer();
    },

    resetInactivityTimer() {
      // 기존 타이머 제거
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }

      // 관리자 페이지인 경우 비활성 타이머 적용하지 않음 (관리자는 무제한 세션)
      const isAdminPage = window.location.pathname.startsWith('/admin');
      if (isAdminPage) {
        return; // 관리자 페이지는 비활성 타이머 없음
      }

      // 로그인 여부 확인 (로그인하지 않은 경우 타이머 설정 안 함)
      // 🔥 사용자: sessionStorage만 사용 (브라우저 닫으면 로그아웃)
      const token = sessionStorage.getItem('auth_token');

      if (!token) {
        return; // 토큰이 없으면 타이머 설정하지 않음
      }

      // 새 타이머 시작 (사용자 페이지만)
      this.inactivityTimer = setTimeout(() => {
        this.handleInactivityLogout();
      }, this.inactivityTimeout);
    },

    handleInactivityLogout() {
      const isAdminPage = window.location.pathname.startsWith('/admin');

      if (isAdminPage) {
        // 관리자 페이지 로그아웃
        const adminToken = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
        if (adminToken) {
          localStorage.removeItem('adminToken');
          sessionStorage.removeItem('adminToken');
          localStorage.removeItem('adminUser');
          localStorage.removeItem('admin_user');
          localStorage.removeItem('auth_token');
          sessionStorage.removeItem('auth_token');
          localStorage.removeItem('user_info');

          alert('30분 동안 활동이 없어 자동 로그아웃되었습니다.');
          window.location.href = '/admin/login';
        }
      } else {
        // 사용자 페이지 로그아웃
        // 🔥 사용자: sessionStorage만 사용 (브라우저 닫으면 로그아웃)
        const userToken = sessionStorage.getItem('auth_token');
        if (userToken) {
          sessionStorage.removeItem('auth_token');
          sessionStorage.removeItem('user_info');

          // Vuex 스토어 초기화
          if (this.$store) {
            this.$store.dispatch('logout');
          }

          alert('30분 동안 활동이 없어 자동 로그아웃되었습니다.');
          this.$router.push('/login');
        }
      }
    },

    clearInactivityTimer() {
      // 이벤트 리스너 제거
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach(event => {
        document.removeEventListener(event, this.resetInactivityTimer, true);
      });

      // 타이머 제거
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
